module.exports = __webpack_public_path__ + "img/icon-dear.02448035.svg";